var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyrelated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45,15h-9V5l-1-1H3L2,5v29l1,1h21v8l1,1h20l1-1V16L45,15z M24,16v17H4V6h14v9h2V6h14v9h-9L24,16z M44,42H26V17h18V42z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 23,
    width: 12,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 27,
    width: 6,
    height: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 0,
    x2: 48,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 47,
    y1: 0,
    x2: 47,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 46,
    y1: 0,
    x2: 46,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 44,
    y1: 0,
    x2: 44,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 43,
    y1: 0,
    x2: 43,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 42,
    y1: 0,
    x2: 42,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 39,
    y1: 0,
    x2: 39,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 37,
    y1: 0,
    x2: 37,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 35,
    y1: 0,
    x2: 35,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 34,
    y1: 0,
    x2: 34,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 33,
    y1: 0,
    x2: 33,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 31,
    y1: 0,
    x2: 31,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 29,
    y1: 0,
    x2: 29,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 26,
    y1: 0,
    x2: 26,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 23,
    y1: 0,
    x2: 23,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 21,
    y1: 0,
    x2: 21,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 19,
    y1: 0,
    x2: 19,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 17,
    y1: 0,
    x2: 17,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 13,
    y1: 0,
    x2: 13,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 11,
    y1: 0,
    x2: 11,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 6,
    y1: 0,
    x2: 6,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 5,
    y1: 0,
    x2: 5,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 4,
    y1: 0,
    x2: 4,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 3,
    y1: 0,
    x2: 3,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 2,
    y1: 0,
    x2: 2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 1,
    y1: 0,
    x2: 1,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 0,
    x2: 0,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 1,
    x2: 0,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 2,
    x2: 0,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 3,
    x2: 0,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 4,
    x2: 0,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 5,
    x2: 0,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 6,
    x2: 0,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 7,
    x2: 0,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 8,
    x2: 0,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 9,
    x2: 0,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 10,
    x2: 0,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 11,
    x2: 0,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 12,
    x2: 0,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 13,
    x2: 0,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 14,
    x2: 0,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 15,
    x2: 0,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 16,
    x2: 0,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 17,
    x2: 0,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 18,
    x2: 0,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 19,
    x2: 0,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 20,
    x2: 0,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 21,
    x2: 0,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 22,
    x2: 0,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 23,
    x2: 0,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 24,
    x2: 0,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 25,
    x2: 0,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 26,
    x2: 0,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 27,
    x2: 0,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 28,
    x2: 0,
    y2: 28
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 29,
    x2: 0,
    y2: 29
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 30,
    x2: 0,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 31,
    x2: 0,
    y2: 31
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 32,
    x2: 0,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 33,
    x2: 0,
    y2: 33
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 34,
    x2: 0,
    y2: 34
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 35,
    x2: 0,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 36,
    x2: 0,
    y2: 36
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 37,
    x2: 0,
    y2: 37
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 38,
    x2: 0,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 39,
    x2: 0,
    y2: 39
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 40,
    x2: 0,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 41,
    x2: 0,
    y2: 41
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 42,
    x2: 0,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 43,
    x2: 0,
    y2: 43
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 44,
    x2: 0,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 45,
    x2: 0,
    y2: 45
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 46,
    x2: 0,
    y2: 46
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 47,
    x2: 0,
    y2: 47
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#00AEEF",
    strokeWidth: 0.05,
    strokeMiterlimit: 10,
    x1: 48,
    y1: 48,
    x2: 0,
    y2: 48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyrelated);
export default __webpack_public_path__ + "static/media/myrelated.eef5019a1fec0423bce41601ff698824.svg";
export { ForwardRef as ReactComponent };